import * as React from "react";
import ReactTable from "react-table";
import { Datos} from "../../../documentos/modelo/Documento";
import { FiltroAgrupadora } from "../modelo/Agrupadora";

export default class TablaParametros extends React.Component<TablaParametrosProps> {

    columns = [{
        Header: "DNI EMPRESA",
        accessor: "dni",
    },{
        Header: "TELEFONO",
        accessor: "phone",
    }];

    render() {
        const {estados,paginas, tamanoPagina, paginaActual} = this.props;

        let numRegistros = 0;
        if (estados.length < tamanoPagina) {
            numRegistros = estados.length;
        } else {
            numRegistros = tamanoPagina;
        }

        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{estados.length}</span> Documentos encontrados
                    </h2>
                </div>
                <ReactTable data={estados}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroAgrupadora = {
            parametro: this.props.filtroDocumento.parametro,
            valor: this.props.filtroDocumento.valor,
            registrosPorPagina: pageSize ? pageSize : tamanoPagina,
            pagina: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
     }

}

interface TablaParametrosProps {
    estados: Array<Datos>,
    filtroDocumento: FiltroAgrupadora,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtroDocumento: FiltroAgrupadora) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/consultar_parametros/componentes/TablaParametros.tsx